<div class="app-admin-layout app-admin-layout--full-height" fxLayout="column">
    <!-- <app-header-top></app-header-top>
    <app-sidebar-nav></app-sidebar-nav>
    <div class="app-admin-container">
        <router-outlet></router-outlet>
    </div> -->
    <router-outlet></router-outlet>
</div>
